<template>
  <div class="list-cards" :class="tableParentClass">
    <Table
      :default-columns="configureColumns"
      :row-data="items"
      :table-action-columns="tableActionColumns"
      :selected-rows="selectedRows"
      has-select-checkbox
      has-sticky-header
      primary-key="ohpDisputeId"
      :config-modal-is-open="configModalIsOpen"
      cell-background="#fff"
      header-cell-background="#f7f7f7"
      :header-position-top="-23"
      v-on="$listeners"
      @checkIsDisabled="checkIsDisabled"
      @addParentClass="addParentClass">
      <template #default="{ row, col }">
        <span v-if="col.slotKey === 'ohpDisputeId'">
          <router-link
            class="title dispute-case-id"
            target="_blank"
            rel="noopener noreferrer"
            :to="`/dispute-case-details/${row[col.slotKey]}`">
            {{ getTableCellValue(row, col) }}
          </router-link>
        </span>
        <span v-else-if="col.slotKey === 'origin'" class="country-container">
          <country-flag :country="getCountryName(row.origin)" size="normal" />
          {{ getTableCellValue(row, col) }}
        </span>
        <span
          v-else-if="col.slotKey === 'destination'"
          class="country-container">
          <country-flag
            :country="getCountryName(row.destination)"
            size="normal" />
          {{ getTableCellValue(row, col) }}
        </span>
        <span
          v-else-if="col.slotKey === 'isFmcRegulated'"
          class="boolean-container">
          {{ getIsFmc(row, col) }}
        </span>
        <span
          v-else-if="col.slotKey === 'isRedisputed'"
          class="boolean-container">
          {{ getIsRedisputeValue(row, col) }}
        </span>
        <span v-else-if="col.slotKey === 'isTender'" class="boolean-container">
          {{ getIsTenderValue(row, col) }}
        </span>
        <span v-else-if="col.slotKey === 'isSpot'" class="boolean-container">{{
          getIsSpotValue(row, col)
        }}</span>
        <span
          v-else-if="col.slotKey === 'redisputeCount'"
          class="boolean-container">
          {{ row[col.slotKey] }}
        </span>
        <span
          v-else-if="col.slotKey === 'case_aging'"
          class="case-aging-container"
          :class="row.caseAging ? row.caseAgingStatus : ''">
          <icon v-if="row.caseAging" name="clock" />
          {{ row.caseAging ? row.caseAging : "N/A" }}
        </span>
        <span
          v-else-if="row[col.slotKey] && col.slotKey === 'resolutionTat'"
          class="case-aging-container"
          :class="row.resolutionStatus">
          <icon v-if="row[col.slotKey]" name="clock" />
          {{ row[col.slotKey] }}
        </span>
        <span
          v-else-if="col.slotKey === 'rejectVoiceTs'"
          class="case-aging-container"
          :class="
            row.rejectVoiceCaseAging ? row.rejectVoiceCaseAgingStatus : ''
          ">
          <icon v-if="row.rejectVoiceCaseAging" name="clock" />
          {{ row.rejectVoiceCaseAging ? row.rejectVoiceCaseAging : "N/A" }}
        </span>
        <span
          v-else-if="col.slotKey === 'inprocessTs'"
          class="case-aging-container"
          :class="row.inProcessCaseAging ? row.inProcessCaseAgingStatus : ''">
          <icon v-if="row.inProcessCaseAging" name="clock" />
          {{ row.inProcessCaseAging ? row.inProcessCaseAging : "N/A" }}
        </span>
        <span v-else-if="col.slotKey === 'statusDescription'">
          <div :class="['dispute-status--table-view']">
            {{ getDisputeStatus(row) }}
          </div>
        </span>
        <span
          v-else
          v-tooltip="getTableCellValueToolip(row, col)"
          class="table-cell">
          {{ getTableCellValue(row, col) }}
        </span>
      </template>
    </Table>
    <configure-modal
      v-if="configModalIsOpen"
      :default-columns="defaultCol"
      :config-columns="configColumns"
      :local-storage-name="cacheNames.tableConfig"
      @saveColumnConfig="saveColumnConfig"
      @onModalClose="onModalClose" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { tableActionColumns, cacheNames } from "@/config/constant.js";

// Custom Components
import ConfigureModal from "@/components/ConfigureListViewModal/ConfigureListViewModal.vue";
import CountryFlag from "vue-country-flag";

// Utils
import { format } from "date-fns";

// Constants
import {
  defaultColumns,
  disputeStatusMapping,
  disputeStatusList,
  configColumns,
} from "@/config/constant.js";

import { countryList } from "@/config/countryList.js";

export default {
  name: "DisputeListView",
  components: {
    ConfigureModal,
    CountryFlag,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    configModalIsOpen: {
      type: Boolean,
      default: false,
    },
    isPending: {
      type: Boolean,
      default: false,
    },
    selectedRows: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      configureColumns: [],
      openConfigModel: false,
      shouldRender: true,
      disputeStatusList: disputeStatusList,
      countryList,
      selectedRow: {},
      defaultCol: defaultColumns,
      tableParentClass: "",
      tableActionColumns,
      configColumns,
      cacheNames,
    };
  },
  computed: {
    ...mapGetters(["getIsEditor"]),
  },
  mounted() {
    let previousConfig = JSON.parse(
      localStorage.getItem(this.cacheNames.tableConfig)
    );
    this.configureColumns = previousConfig
      ? previousConfig
      : [...this.defaultCol];
  },
  methods: {
    format,
    addParentClass(val) {
      this.tableParentClass = val;
    },
    onModalClose() {
      this.$emit("onModalClose", false);
      //force rendering to update slot
      this.forceRender();
    },
    async saveColumnConfig(config) {
      this.configureColumns = config;
    },
    forceRender() {
      //removing column component
      this.shouldRender = false;
      this.$nextTick(() => {
        //adding column component
        this.shouldRender = true;
      });
    },
    handleDisputeStatusClick(row) {
      if (this.selectedRows?.length) {
        if (this.selectedRows.includes(row.ohpDisputeId)) {
          this.selectedRow = row;
          this.$emit("onUpdateDisputeStatus", row);
        }
      } else {
        this.selectedRow = row;
        this.$emit("onUpdateDisputeStatus", row);
      }
    },
    handleDisputeStatusInput() {},
    getCountryName(data) {
      return data
        ? this.countryList[`${data.split(",").pop().trim().toLowerCase()}`]
        : "";
    },
    getDisputeStatus(row) {
      return disputeStatusMapping[`${row.statusCode}`];
    },
    getTableCellValue(row, col) {
      const value = row[col.slotKey];
      if (col.type === "date") {
        try {
          return value ? format(new Date(value), "dd-MMM-yyyy hh:mm a") : "N/A";
        } catch (err) {
          return value;
        }
      }
      return !value || typeof value === "undefined" || value === "null"
        ? "-"
        : value;
    },
    getTableCellValueToolip(row, col) {
      const value = row[col.slotKey];
      if (col.type === "date") {
        try {
          return value ? format(new Date(value), "dd-MMM-yyyy hh:mm a") : "N/A";
        } catch (err) {
          return value;
        }
      } else {
        return value;
      }
    },
    getIsFmc({ isFmcRegulated }) {
      return isFmcRegulated || "Not Available";
    },
    getIsRedisputeValue({ isRedisputed }) {
      return isRedisputed ? "Yes" : "No";
    },
    getIsTenderValue({ isTender }) {
      return isTender ? "Yes" : "No";
    },
    getIsSpotValue({ isSpot }) {
      return isSpot ? "Yes" : "No";
    },
    checkIsDisabled(row) {
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/imports";

$table-border: #e8eaec;
.list-cards {
  background-color: var(--Gray-50);
  border-radius: 0.25rem;
  margin-right: 1.5rem;
  margin-bottom: 1.5rem;
  margin: 20px 0;

  @media (min-width: 1200px) {
    width: 100%;
  }

  & .action_button_area {
    width: 20rem;

    & .actionButton {
      width: 290px;
    }
  }

  & .list-header {
    background-color: var(--alt-color);
  }

  & .row--stripe {
    background-color: var(--red);
  }

  & .title {
    font-family: "Maersk Text";

    &.dispute-case-id {
      color: var(--Blue-600-Dark);
    }
  }

  & .dispute-status {
    &--table-view {
      & .button.button--tertiary.button--small.button--block {
        width: 19rem;
        text-align: left;
      }
      &--disabled {
        & .button.button--tertiary.button--small.button--block {
          cursor: not-allowed;

          &:hover {
            color: #353535;
            background-color: #fff;
            border-color: #cfcfcf;
            box-shadow: none;
          }
        }
      }
    }
  }
  & .case-aging-container {
    display: flex;
    align-items: center;
    font-size: 12px;
    font-weight: 600;
    border-radius: 2px;
    padding: 4px 8px;
    width: 132px;
    i {
      margin-right: 4px;
    }
    &.LOW,
    &.MEDIUM {
      background: #c5e5c2;
    }
    &.HIGH {
      background: #ffeba8;
    }
    &.CRITICAL {
      background: #e9b2b7;
    }
  }
}
</style>

<style lang="scss">
@import "@/styles/imports";

.dashboard {
  & .list-cards {
    & .actionButton {
      & button {
        font-size: 10px;
      }

      & .dropdown {
        position: inherit;
      }
    }
  }
  .table-parent-style {
    overflow: auto;
  }
}
</style>
